export const termsRoute: Route = {
  title: 'ข้อตกลงการใช้บริการ',
  href: 'https://pdpa.pro/prokit/terms-of-use',
}

export const policyRoute: Route = {
  title: 'นโยบายการรักษาข้อมูลส่วนตัว',
  href: 'https://pdpa.pro/prokit/privacy-policy',
}
